import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '420px': isMobileBig ? '450px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '450px' : '500px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px'
})

export const card_14_01_25 = {

  date: '14-01-2025',
  routeCard: '/nutricao/beneficios-do-cha-de-mulungu/14-01-2025',
  description: 'Benefícios do chá de Mulungu. Um aliado anti-estresse',
  month: 'Janeiro',
  shortTitle: 'Mulungu: Acabe com a ansiedade',
  elements: [
    {
      type: 'title',
      content: 'Benefícios do chá de Mulungu',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          <p style="text-indent: 20px;">O chá de Mulungu é conhecido por suas propriedades calmantes e relaxantes.
          Ele é frequentemente usado para ajudar a tratar ansiedade, insônia e estresse.
          A arvore que dá origem ao chá é nativa do Brasil e Paraguai.
          Para prepará-lo, basta ferver as folhas ou a casca da árvore por cerca de 10 minutos, pelo método da infusão.
          O resultado é uma bebida aromática que promove o bem-estar.
          Estudos mostram que a planta possui propriedades sedativas, ansiolíticas e anticonvulsivas.
          </p>
          `,
          getStyles: textB,
        },
        {
          type: 'image',
          content: cardImages.mulungu_18_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'title',
      content: 'Principais nutrientes do Mulungu',
      getStyles: titleA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'list',
          content: [
            'Flavonoides: Um grupo de compostos químicos com várias propriedades, incluindo flavanonas, flavonóis, chalconas e cinamoilfenóis.',
           'Alcaloides: Os compostos mais biologicamente ativos do mulungu, incluindo eritravina e 11-alfa-hidroxi-eritravina.',
           'Taninos: Um antioxidante polifenólico encontrado na casca do mulungu.',
           'Glicosídeos amargos: Compostos presentes na casca do mulungu.',
          ],
          getStyles: listA,
        }
      ],
      getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.erythrina_18_01_25,
          getStyles: imageA,
        },
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">A arvore Erythrina Mulungu é uma espécie nativa da América do Sul,
          e comum no cerrado brasileiro. Possui de 8 a 12m de altura , com tronco e caules de cascas lisas.
          Suas flores são laranjas vistosas em forma de candelabro. 
          Floresce de julho a setembro quando, nos lugares mais frios e secos, perde todas as folhas.
          </p>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'title',
      content: 'Como preparar o chá',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'list',
          content: [
            'Flavonoides: Um grupo de compostos químicos com várias propriedades, incluindo flavanonas, flavonóis, chalconas e cinamoilfenóis.',
           'Alcaloides: Os compostos mais biologicamente ativos do mulungu, incluindo eritravina e 11-alfa-hidroxi-eritravina.',
           'Taninos: Um antioxidante polifenólico encontrado na casca do mulungu.',
           'Glicosídeos amargos: Compostos presentes na casca do mulungu.',
          ],
          getStyles: listA,
        }
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
  ] as ElementType[],
  tags: ['nutrição', 'chá', 'mulungu', 'ioga', 'oriente'],
  author: 'John Doe',
}


